import { render, staticRenderFns } from "./Switcher.vue?vue&type=template&id=c5d7a33c&scoped=true&"
import script from "./Switcher.vue?vue&type=script&lang=js&"
export * from "./Switcher.vue?vue&type=script&lang=js&"
import style0 from "./Switcher.vue?vue&type=style&index=0&id=c5d7a33c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d7a33c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
